import React from "react";
import {FaFacebookF,FaInstagram,FaTwitter,FaPhoneAlt,FaMapMarkerAlt,FaEnvelope,} from "react-icons/fa";
import Logo from "../assets/logo-schools.webp";
import { Link } from "react-router-dom";

import {
  FaYoutube,
  
  FaLinkedinIn,
  FaXTwitter,
} from "react-icons/fa6"; 

export default function Footer() {

   const closeMenu = () =>{
    
    window.scrollTo({top:0,behavior:"smooth"})
   } 
  return (
    <div className="w-full m-0 p-0 bg-white">
      {/* Logo */}
      {/* <div className="flex justify-center">
        <img src={Logo} className="h-30 mb-5 rounded-xl mt-4" alt="Rankridge Logo" />
      </div> */}

      {/* Footer Content */}
      <footer className="w-full bg-[#018b81] text-white py-10 px-4 md:px-16 xl:px-24 rounded-t-3xl">
        <div className="max-w-7xl m-4 mx-auto grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-8">
          {/* Contact Us */}
          <div>
            <h4 className="text-xl font-bold mb-4">Contact Us</h4>
                      <a href="tel:+919959303873" >
   <p className="flex items-center gap-2 mb-2">
              <FaPhoneAlt /> +91 99 59 303 873
            </p> </a>
            <p className="flex items-center gap-2 mb-2">
              <FaEnvelope /> admissions@rankridgeschools.com
            </p>
            <p className="flex items-center gap-2">
              <FaMapMarkerAlt /> CO Branch :: KPHB Kukatpally
            </p>
            <p className="flex items-center gap-2">
               <pre>   Hyderabad, Telangana</pre>     
            </p>
             <p className="flex items-center gap-2">
              <FaMapMarkerAlt /> Vijayawada, Guntur, Vizag, Tirupati - 
            </p>
            <p className="flex items-center gap-2 ms-5">Andhrapradesh</p>
            <p className="flex items-center gap-2 ms-5">
             Chennai, Banglore, Pune, Mumbai & Delhi - India
            </p>
            {/* Social Icons Full Width Bar */}
            <div  className="w-full bg-white p-6 px-3 mt-4 flex justify-between gap-4 rounded-lg border-2  border-[black]">
              <a href="https://www.youtube.com/@RankridgeSchools" target="_blank" rel="noopener noreferrer">
                <FaYoutube className="text-[#FF0000] text-2xl hover:scale-110 transition" />
              </a>
              <a href="https://www.instagram.com/rankridgeschools/" target="_blank" rel="noopener noreferrer">
                <FaInstagram className="text-[#C13584] text-2xl hover:scale-110 transition" />
              </a>
              <a href="https://x.com/RankridgeSchool" target="_blank" rel="noopener noreferrer">
                <FaXTwitter className="text-black text-2xl hover:scale-110 transition" />
              </a>
              <a href="https://www.facebook.com/RankridgeSchools/" target="_blank" rel="noopener noreferrer">
                <FaFacebookF className="text-[#1877F2] text-2xl hover:scale-110 transition" />
              </a>
              <a href="https://www.linkedin.com/company/rankridgeschools" target="_blank" rel="noopener noreferrer">
                <FaLinkedinIn className="text-[#0A66C2] text-2xl hover:scale-110 transition" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="lg:mt-0 md:mt-0 lg:ml-0">
            <h4 className="text-xl font-bold mb-4 text-center">Quick Links</h4>
            <div className="grid grid-cols-2 ">
            <ul className="space-y-2 text-white">
              <li><Link to="/"  onClick={closeMenu} className="hover:text-green-300">Home</Link></li>
              <li><Link to="/about" onClick={closeMenu} className="hover:text-green-300">About</Link></li>
              <li><Link to="/academics" onClick={closeMenu}  className="hover:text-green-300">Academics</Link></li>
              <li><Link to="/admissions" onClick={closeMenu} className="hover:text-green-300">Admissions</Link></li>
              <li><Link to="/student" onClick={closeMenu} className="hover:text-green-300">Student Life</Link></li>
              <li><Link to="/events" onClick={closeMenu} className="hover:text-green-300">Events</Link></li>
            </ul>
<ul className="space-y-2 text-black">
              <li><Link to="/pre-primary" onClick={closeMenu}  className="block text-black hover:text-green-900">Pre Primary</Link></li>
                             <li> <Link to="/primary-school" onClick={closeMenu}  className="block text-black hover:text-green-900">Primary</Link></li>
                              <li><Link to="/middle-to-secondary" onClick={closeMenu}  className="block text-black hover:text-green-900">Middle TO Secondary </Link></li>
                             <li><Link to="/cbse-curriculum" onClick={closeMenu}  className="block text-black hover:text-green-900">CBSE </Link></li>
                             <li><Link to="/stateboard" onClick={closeMenu}  className="block text-black hover:text-green-900">StateBoard</Link></li>
                                          <li><Link to="/iit-jee-neet-foundation" onClick={closeMenu}  className="block text-black hover:text-green-900">IIT-JEE & NEET Foundation</Link></li>

            </ul>
          </div>
          </div>

          {/* Google Map */}
          <div className="col-span-1 md:col-span-2 xl:col-span-2 lg:ml-0">
            <h4 className="text-xl font-bold mb-4">Find Us</h4>
            <div className="overflow-hidden rounded-lg shadow-lg h-64">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d475.67036325645654!2d78.3948341!3d17.4901814!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb915ba16b6a93%3A0x89777823a0ce54cf!2sRankridge%20Schools%20-%20KPHB%20%7C%20Best%20Schools%20with%20IIT-JEE%20%26%20NEET%20Foundation%20Hyderabad!5e0!3m2!1sen!2sin!4v1751180274092!5m2!1sen!2sin"
                width="100%"
                height="100%"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Rankridge Location"
              ></iframe>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="text-center mt-10 border-t pt-6 text-sm text-black">
        All rights reserved  - {new Date().getFullYear()} @     <br></br>Rankridge International Schools. 
        </div>
      </footer>
    </div>
  );
}
